/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Nav_CommunityInputs */



/**
* | output |
* | --- |
* | "Community" |
*
* @param {Nav_CommunityInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const nav_community = /** @type {((inputs?: Nav_CommunityInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Nav_CommunityInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Communauté")
	if (locale === "es") return /** @type {LocalizedString} */ ("Comunidad")
	if (locale === "pt") return /** @type {LocalizedString} */ ("Comunidade")
	if (locale === "it") return /** @type {LocalizedString} */ ("Comunità")
	return /** @type {LocalizedString} */ ("Community")
});